var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M2.02512 3.24017C2.71707 3.24017 3.27802 2.67923 3.27802 1.98727C3.27802 1.29532 2.71707 0.734375 2.02512 0.734375C1.33316 0.734375 0.772217 1.29532 0.772217 1.98727C0.772217 2.67923 1.33316 3.24017 2.02512 3.24017Z",
    fill: "#1D1D46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M5.78381 1.48926C5.50767 1.48926 5.28381 1.71312 5.28381 1.98926C5.28381 2.2654 5.50767 2.48926 5.78381 2.48926L17.2279 2.48926C17.5041 2.48926 17.7279 2.2654 17.7279 1.98926C17.7279 1.71312 17.5041 1.48926 17.2279 1.48926L5.78381 1.48926Z",
    fill: "#1D1D46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M5.78381 6.50195C5.50767 6.50195 5.28381 6.72581 5.28381 7.00195C5.28381 7.2781 5.50767 7.50195 5.78381 7.50195L17.2279 7.50195C17.5041 7.50195 17.7279 7.2781 17.7279 7.00195C17.7279 6.72581 17.5041 6.50195 17.2279 6.50195L5.78381 6.50195Z",
    fill: "#1D1D46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M5.28381 12.0146C5.28381 11.7385 5.50767 11.5146 5.78381 11.5146L17.2279 11.5146C17.5041 11.5146 17.7279 11.7385 17.7279 12.0146C17.7279 12.2908 17.5041 12.5146 17.2279 12.5146L5.78381 12.5146C5.50767 12.5146 5.28381 12.2908 5.28381 12.0146Z",
    fill: "#1D1D46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M2.02487 13.2646C2.71683 13.2646 3.27777 12.7036 3.27777 12.0117C3.27777 11.3197 2.71683 10.7588 2.02487 10.7588C1.33291 10.7588 0.771973 11.3197 0.771973 12.0117C0.771973 12.7036 1.33291 13.2646 2.02487 13.2646Z",
    fill: "#1D1D46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M3.27777 7.00095C3.27777 7.6929 2.71683 8.25385 2.02487 8.25385C1.33291 8.25385 0.771973 7.6929 0.771973 7.00095C0.771973 6.30899 1.33291 5.74805 2.02487 5.74805C2.71683 5.74805 3.27777 6.30899 3.27777 7.00095Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSample);
export default __webpack_public_path__ + "static/media/sample.86ddde47fda5ae9d0aea1237200896fd.svg";
export { ForwardRef as ReactComponent };